import { TargetComponents } from '../../../types';

export const getTargetComponentsFormattedDisplayNames = (
  targetComponents: TargetComponents,
): string => {
  return new Set(
    [
      targetComponents.leadingGroupInfo.displayName,
      ...targetComponents.subsetGroupInfos.map((info) => info.displayName),
    ].filter(Boolean),
  )
    .values()
    .toArray()
    .join('\n');
};
